class CustomQuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.handleDelegateClick);
        this.themeTexts = {}
        if(document.querySelector('#theme-strings')) {
            this.themeTexts = JSON.parse(document.querySelector('#theme-strings').textContent)
        }
    }

    connectedCallback() {}

    disconnectedCallback() {
        this.removeEventListener('click', this.handleDelegateClick);
    }

    handleDelegateClick(event) {
        const sizeOptionItem = event.target.closest('.size-option-item');
        const quantityButtonQuantityText = document.querySelector('#selected-quantity-button #quantity');
        const quantityButtonPricePerShakeText = document.querySelector('#selected-quantity-button #price-per-shake');
        const quantityButtonPortionText = document.querySelector('#selected-quantity-button #price-per-portion');
        const quantityButtonPrice = document.querySelector('#selected-quantity-button .price');

        if (sizeOptionItem) {
            document.querySelector('.size-option-item.selected')?.classList.remove('selected')
            sizeOptionItem.classList.add('selected');
            this.handleClick(sizeOptionItem);
    
            if(quantityButtonQuantityText) {
                quantityButtonQuantityText.innerHTML = sizeOptionItem.dataset.quantity || '';
            }
    
            if(quantityButtonPricePerShakeText) {
                quantityButtonPricePerShakeText.innerHTML = sizeOptionItem.dataset.pricePerShake || '';
            }
    
            if(quantityButtonPortionText) {
                quantityButtonPortionText.innerHTML = sizeOptionItem.dataset.portion || '';
            }
    
            if (quantityButtonPrice) {
                quantityButtonPrice.innerHTML =  sizeOptionItem.dataset.price || '';
            }
        }
    }

    handleClick(item) {
        this.closeOpenPopovers();
        const { variantId, available, price } = item.dataset;
        const buyButton = document.querySelector('.product-info__buy-buttons button');
        const priceElement = document.querySelector('price-list sale-price');
        if (document.querySelector('.product-info__buy-buttons input[name="id"]') && available) {
            document.querySelector('.product-info__buy-buttons input[name="id"]').value = variantId;
        }
        if (buyButton) {
            if (available === 'true') {
                buyButton.disabled = false
                buyButton.innerHTML = this.themeTexts.addToCartButtonText
            } else {
                buyButton.disabled = true;
                buyButton.innerHTML = this.themeTexts.soldOutButtonText
            }
        }

        priceElement.innerHTML = price;
    }

    closeOpenPopovers() {
        const popovers = this.querySelectorAll('custom-quantity-selector button[aria-expanded="true"]');
        popovers.forEach(popover => {
            popover.click();
        });
    }
}

class CustomModal extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });

        const overlay = document.createElement('div');
        overlay.classList.add('modal-overlay');
        overlay.style.display = 'none';

        const content = document.createElement('div');
        content.classList.add('modal-content');

        const closeButton = document.createElement('button');
        closeButton.classList.add('close-button');
        closeButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1505 17.391L6.90734 6.14783L5.84668 7.20849L17.0898 18.4517L18.1505 17.391Z" fill="#070707"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.8495 17.391L17.0927 6.14783L18.1533 7.20849L6.91016 18.4517L5.8495 17.391Z" fill="#070707"/>
        </svg>
        `;
        closeButton.onclick = () => this.close();

        content.appendChild(closeButton);
        content.appendChild(document.createElement('slot')); // Slot for nested content
        overlay.appendChild(content);

        // Append styles and structure to shadow DOM
        const style = document.createElement('style');
        style.textContent = `
            .modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.7);
                display: flex;
                justify-content: center;
                align-items: flex-end;
                animation: slideIn 0.3s ease-out;
                z-index: 9;
            }
            .modal-content {
                background-color: white;
                width: 90%;
                max-height: var(--custom-modal-height);
                overflow-y: auto;
                border-radius: 8px;
                padding: 0 20px 20px;
                position: relative;
                max-width: 500px
            }
            .close-button {
                position: absolute;
                top: 10px;
                left: 10px;
                background: none;
                border: none;
                font-size: 16px;
                cursor: pointer;
            }
            @keyframes slideIn {
                from {
                    transform: translateY(100%);
                }
                to {
                    transform: translateY(0);
                }
            }
        `;

        this.shadowRoot.append(style, overlay);

        // Add event listener to close modal when clicking on the overlay
        overlay.addEventListener('click', (event) => {
            if (event.target === overlay) {
                this.close();
            }
        });
    }

    open() {
        if(window.innerWidth > 767 && this.getAttribute('data-mobile-only') === 'true') return
        const overlay = this.shadowRoot.querySelector('.modal-overlay');
        overlay.style.display = 'flex';
        document.body.classList.add('no-scroll'); // Prevent scrolling
    }

    close() {
        const overlay = this.shadowRoot.querySelector('.modal-overlay');
        overlay.style.display = 'none';
        document.body.classList.remove('no-scroll'); // Allow scrolling
    }

    connectedCallback() {
        // Find the button in the light DOM and attach the open event
        this.previousElementSibling.addEventListener('click', () => this.open());
    }
}

class CustomProductRerender extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.getAttribute('section-id');
        this.contentSelector = this.getAttribute('selector');
    }

    connectedCallback() {
        this.form = document.querySelector('.product-info__buy-buttons .shopify-product-form');
        this.form.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
        this.fetchSectionContent();
    }

    fetchSectionContent() {
        const selectedOption = document.querySelector('.variant-picker__option input[data-option-position]:checked');
        if (selectedOption) {
            const optionId = selectedOption.getAttribute('value');
            const url = `${window.location.pathname}?section_id=${this.sectionId}&option_values=${optionId}`;
            fetch(url)
                .then(response => response.text())
                .then(html => this.updateContent(html))
                .catch(error => console.error('Error fetching section:', error));
        }
    }

    updateContent(html) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        this.contentSelector.split(',').forEach((selector) => {
            const newContent = wrapper.querySelector(selector);
            const contentElement = this.querySelector(selector);
            const parentAccordionEl = contentElement.closest('.accordion');
            
            if (newContent && newContent.innerHTML.trim() !== '') {
              parentAccordionEl.classList.remove('hidden');
              contentElement.innerHTML = newContent.innerHTML;
            } else {
              parentAccordionEl.classList.add('hidden');
              contentElement.innerHTML = '';
            }
        })
    }

    disconnectedCallback() {
        this.form.removeEventListener('variant:change', this.handleVariantChange.bind(this));
    }
}

class BundleSelection extends HTMLElement {
  static elementName = 'bundle-selection';
  static inputValueDelimiter = ' <> '

  constructor() {
    super();

    this.config = this.getConfig();
    this.elems = this.getElems();

    this.elems.selects.forEach(select => select.addEventListener('change', this.handleChange.bind(this)));
  }

  handleChange() {
    const newInputValue = this.elems.fields.map(field => field.value).join(BundleSelection.inputValueDelimiter);
    this.updateMainInput(newInputValue);
  }

  updateMainInput(newValue) {
    this.elems.mainInput.value = newValue;
  }

  getElems() {
    return {
      fields: [...this.querySelectorAll('[data-bundle-selection-field')],
      selects: [...this.querySelectorAll('[data-bundle-selection-select')],
      inputs: [...this.querySelectorAll('[data-bundle-selection-input')],
      mainInput: this.querySelector('[data-bundle-selection-main-input'),
    }
  }

  getConfig() {
    return JSON.parse(this.querySelector('[data-config]').innerText);
  }
}

if (!customElements.get('custom-modal')) {
  customElements.define('custom-modal', CustomModal);
}

if (!customElements.get('custom-quantity-selector')) {
  customElements.define('custom-quantity-selector', CustomQuantitySelector);
}

if (!customElements.get('custom-product-rerender')) {
  customElements.define('custom-product-rerender', CustomProductRerender);
}

if (!customElements.get(BundleSelection.elementName)) {
  customElements.define(BundleSelection.elementName, BundleSelection);
}
